import { en } from '../i18n/en.js'
import { es } from '../i18n/es.js'
import { fr } from '../i18n/fr.js'

export const messages = {
  en,
  es,
  fr,
}
